import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../src/assets/images/Farmadati_logo_2.jpg'


const _hoisted_1 = { style: {"margin-top":"3%","margin-left":"17%","margin-right":"17%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "quick-btn",
  href: "https://www.farmadati.it",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"11%","height":"auto","display":"inline-block"}
  })
], -1)
const _hoisted_3 = { style: {"text-align":"left"} }

import {
  downloadTerapie, previewTerapie, downloadReport
} from "../../../../EshJSLib/services/donwloadService";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmaciFooter',
  setup(__props) {


const store = patientStore();
const { patient } = storeToRefs(store);

function currentDate() {
      //const current = new Date();
      var d = new Date();
      d.setDate(d.getDate() - 1);
      const date = `${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`;
      return date;
    }

function download() {
  downloadTerapie(patient.value.id_paziente);
}

function preview() {
  previewTerapie(patient.value.id_paziente);
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_font_awesome_layers = _resolveComponent("font-awesome-layers")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", null, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('farmaciTxt')) + " " + _toDisplayString(currentDate()), 1),
      _createVNode(_component_font_awesome_layers, {
        class: "fa-lg",
        style: {"margin-top":"2%"},
        onClick: preview
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-print",
            style: {color:'black'},
            size: "2xl"
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})